import { Ref } from 'vue'

import { Incident } from '@collector/sportsapi-client'
import { IncidentId } from '@collector/sportsapi-client-legacy'

export function incidentsUpdate(
  incident: Incident,
  incidents: Ref<Incident[], Incident[]>,
  lastNonDeletedIncident: Ref<Incident | undefined>,
  lastNonDeletedIncidentWithPosition: Ref<Incident | undefined>,
  findLastNonDeletedIncident: (incidents: Incident[]) => Incident | undefined,
  findLastNonDeletedIncidentWithPosition: (
    incidents: Incident[],
  ) => Incident | undefined,
  hasPosition: (incident: Incident) => boolean,
  isIncidentDeleted: (incident: Incident) => boolean,
  incidentsToTrackUpdate: Set<IncidentId>,
): void {
  function recalculateLastNonDeletedIncidentWithPosition(): void {
    lastNonDeletedIncidentWithPosition.value =
      findLastNonDeletedIncidentWithPosition(incidents.value)
  }

  function isIncidentUpdateTracked(): boolean {
    return (
      incident.action === 'update' &&
      incidentsToTrackUpdate.has(incident.incident_id)
    )
  }
  if (incident.action === 'delete') {
    if (incident.id === lastNonDeletedIncident.value?.id) {
      lastNonDeletedIncident.value = findLastNonDeletedIncident(incidents.value)
    }
    if (incident.id === lastNonDeletedIncidentWithPosition.value?.id) {
      recalculateLastNonDeletedIncidentWithPosition()
    }
  } else if (incident.action === 'insert') {
    lastNonDeletedIncident.value = incident
    if (hasPosition(incident)) {
      lastNonDeletedIncidentWithPosition.value = incident
    }
  } else if (incident.action === 'update') {
    if (isIncidentUpdateTracked()) {
      lastNonDeletedIncident.value = incident
      if (hasPosition(incident)) {
        lastNonDeletedIncidentWithPosition.value = incident
      } else if (incident.id === lastNonDeletedIncidentWithPosition.value?.id) {
        recalculateLastNonDeletedIncidentWithPosition()
      }
    } else if (incident.id === incidents.value[incidents.value.length - 1].id) {
      recalculateLastNonDeletedIncidentWithPosition()
    }
  }
}
